// extracted by mini-css-extract-plugin
module.exports = {"w1h25yb2":"w1h25yb2"};